import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { CityInfoByGeoRadiusResponse } from 'store/api/api.types';
import { convertError } from 'store/api/apiUtils';
import { FieldValue } from 'core/constant/FieldValue';
import { IMeasurementTags } from '@agoda/messaging-client';
import { MeasurementStatus } from 'core/constant/MeasurementStatus';
import { MeasurementName } from 'core/constant/MeasurementName';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { sendMeasurement } from 'core/messaging/measurement/measurement';
import { logInfo, logWarn } from 'core-framework/util/LogMessage';

const sendCityByGeoRadiusApiMeasurements = (
    message: string,
    measurementName: MeasurementName,
    pageTypeId: ActivitiesPageTypes,
    config: BootstrapConfig,
    tags: IMeasurementTags,
): boolean => {
    const measurement = buildMeasurement('getCityBygeoRadiusResult', measurementName, pageTypeId, message, 1, false, config);
    measurement.tags = {
        ...measurement.tags,
        ...tags,
    };
    sendMeasurement({ ...measurement, name: MeasurementName.ApiTranslationStatus }, pageTypeId);

    if (measurementName === MeasurementName.ApiTranslationSuccess) {
        logInfo(message, pageTypeId, measurement.tags);
        return true;
    }
    logWarn(message, pageTypeId, measurement.tags);
    return true;
};

export const measureCityByGeoRadiusApiResponse = (response: CityInfoByGeoRadiusResponse, pageTypeId: ActivitiesPageTypes, config: BootstrapConfig): boolean => {
    const error = convertError(response.error) || { status: FieldValue.Undefined, message: FieldValue.Undefined };
    const messageLowerCase = error.message.toLowerCase();
    const measurementTags: IMeasurementTags = {
        statusCode: error.status.toString(),
    };
    if (response.isSuccess) {
        const numberOfResults = (response?.data && Object.keys(response.data).length) ?? 0;
        measurementTags.status = MeasurementStatus.Success;
        if (numberOfResults === 0) {
            return sendCityByGeoRadiusApiMeasurements('no results', MeasurementName.CityGeoRadiusNoResult, pageTypeId, config, measurementTags);
        }
        return sendCityByGeoRadiusApiMeasurements('success', MeasurementName.CityGeoRadiusSuccess, pageTypeId, config, measurementTags);
    }
    measurementTags.status = MeasurementStatus.Failed;
    return sendCityByGeoRadiusApiMeasurements(messageLowerCase, MeasurementName.CityGeoRadiusError, pageTypeId, config, measurementTags);
};
